<template>
  <div class="serp__filter-item--dropdown">
    <div class="q-dropdown q-position-relative" v-click-outside="closeDropdown">
      <DropdownButton @click="isOpen = !isOpen" :label="filter.label" :is-open="isOpen"/>
      <ul v-if="isOpen" class="q-dropdown-menu q-shadow-sm q-rounded-3"
          :class="computedClass">
        <li class="input-group input-group-sm mb-1 filter-search__container"
            v-if="!forbiddenSearchTypes">
          <input type="text" class="q-form-control filter-search__input" aria-label="Filter search input"
                 :placeholder="SmartSearchTranslations.serp.filterSearchHeader" v-model="searchQuery">
        </li>
        <li class="dropdown-divider__container" v-if="!forbiddenSearchTypes">
          <hr class="dropdown-divider">
        </li>
        <CheckboxItem v-if="filter.type === 'checkbox'" :filterDataValues="filteredValues"
                      :field="filter.field" @closeDropdown="isOpen = false"/>
        <BoxItem v-if="filter.type === 'box' " :filterDataValues="filteredValues" :field="filter.field"
                 @closeDropdown="isOpen = false"/>
        <InputRangeItem v-if="filter.type === 'range'" :filterData="filter.data" :field="filter.field"
                        @closeDropdown="isOpen = false"/>
        <MultiRangeSlider v-if="filter.type === 'rangeSlider'" :filterData="filter.data" :field="filter.field"
                          @closeDropdown="isOpen = false"/>
        <CategoryItem v-if="filter.type === 'category'" :filterData="filter.data" :field="filter.field"
                      @closeDropdown="isOpen = false"/>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {computed, defineProps, ref, inject} from 'vue';
import DropdownButton from '@/components/SerpPage/FiltersContainer/FiltersList/DropdownButton.vue'
import InputRangeItem from './FilterItem/InputRangeItem.vue'
import CategoryItem from './FilterItem/CategoryItem.vue'
import CheckboxItem from './FilterItem/CheckboxItem.vue'
import BoxItem from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/BoxItem.vue";
import MultiRangeSlider from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/MultiRangeSlider.vue";
import {SmartSearchTranslationsInterface} from "@/core/types";

const isOpen = ref(false);

const props = defineProps(['filter'])
const forbiddenSearchTypes = computed(()=>{
  return props.filter.type === 'range' || props.filter.type === 'rangeSlider' || props.filter.type === 'category'
})

const computedClass = computed(() => {
      if (props.filter.type === 'box') {
        return `serp__filter-item--${props.filter.type}`
      }
      const classList = [
        'serp__filter-item--group',
        `serp__filter-item--${props.filter.type}`,
        'q-list-group',
        'q-list-group-flush',
        'q-list-group-collapse',
      ]
      if (isOpen.value) {
        classList.push('q-d-block')
      }
      return classList
    })
;

let searchQuery = ref('');
const filteredValues = computed(() => {
  if (searchQuery.value === '') {
    return props.filter.data.values;
  } else {
    return props.filter.data.values.filter(value => value.label.toLowerCase().includes(searchQuery.value.toLowerCase()));
  }
})
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

function closeDropdown() {
  isOpen.value = false
}

</script>
<style scoped>
.dropdown-divider__container, .filter-search__container {
  grid-column: 1 / -1;
}

.q-dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 1rem;
  margin: 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25rem;
  width: max-content;
  max-width: 300px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

}

.filter-type__box {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  width: max-content !important;
}

.q-dropdown-header {
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.serp__filter-item--container {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

}

.serp__filter-item--box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-options {
  display: block;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  height: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-options div {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-options div:hover {
  background-color: #f1f1f1;
}
.q-form-control.filter-search__input:focus{
  border-color: var(--q-red)!important;
}

</style>